import { Button, Slider, Stack, Tooltip } from '@mui/material'
import _ from 'lodash'
import * as React from 'react'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import SliderRecordCall from '../../../../components/SliderRecordCall'
import colors from '../../../../constants/colors'
import { AnnotationLineItemT } from '../../../../types/AnnotationLineItemT'
import { parseFloatTotal } from '../../../../utils/utilsT'


interface IAnnotationPhone {
    duration: number
    annotationType?: string     // 'dispute' | 'sales'
    item: PhoneAnnotationT
    index: number
    updateLineItem(index: number, item: PhoneAnnotationT): void
    removeLineItem(index: number): void
    displayMode?: "edit" | "view"
}


export interface PhoneAnnotationT extends AnnotationLineItemT {
    endTime?: number
    notes: string
    startTime?: number
    title: string
}

export const PhoneAnnotationObject: PhoneAnnotationT = {
    endTime: null,
    notes: "",
    startTime: null,
    title: ""
}



const AnnotationPhone: React.FC<IAnnotationPhone> = (props: IAnnotationPhone): JSX.Element => {

    const [annotation, setAnnotation] = React.useState<PhoneAnnotationT>()


    const onChangeValue = (key: string, value: any) => {
        let cloneItem = _.cloneDeep(props?.item)
        cloneItem[key] = value
        props.updateLineItem(props.index, cloneItem)
    }


    return (
        <Container className='mt-4' style={{ textAlign: 'left', position: "relative" }}>
            <SliderRecordCall
                disabled={props?.displayMode != "edit"}
                duration={props.duration}
                values={{
                    startTime: props?.item?.startTime,
                    endTime: props?.item?.endTime,
                }}
                onChangeValues={(values) => {
                    if (props?.displayMode == "edit") {
                        let cloneItem = _.cloneDeep(props?.item)
                        cloneItem["startTime"] = values.startTime
                        cloneItem["endTime"] = values.endTime
                        props.updateLineItem(props.index, cloneItem)
                    }

                }}
            />
            {/* <Row>
                <Col>
                    <Form.Group as={Row}>
                        <Form.Label column sm="4">Start Time</Form.Label>
                        <Col sm="8">
                            <Form.Control
                                className='input-material'
                                value={annotation && annotation.startTime ? annotation.startTime : ''} />
                        </Col>
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group as={Row}>
                        <Form.Label column sm="4">End Time</Form.Label>
                        <Col sm="8">
                            <Form.Control
                                className='input-material'
                                value={annotation && annotation.endTime ? annotation.endTime : ''} />
                        </Col>
                    </Form.Group>
                </Col>
            </Row> */}
            <Row className='mt-2'>
                <Col>
                    {props?.displayMode == "edit" ? <Form.Group>
                        <Form.Label>Summary</Form.Label>
                        <Form.Control as="textarea"
                            value={`${props?.item?.notes}`}
                            rows={3} onChange={(event: any) => {
                                let value = event.target.value
                                onChangeValue("notes", value)
                            }} />
                    </Form.Group> : <Stack flexDirection={"column"}>
                        <Form.Label>Summary</Form.Label>
                        <Stack className='' p={2} style={{ border: "1px solid #ccc" }}>
                            <span>{props?.item?.notes}</span>
                        </Stack>
                    </Stack>}
                </Col>
            </Row>
            {props?.displayMode == "edit" && <div style={{
                position: "absolute",
                top: -2,
                right: -20,
                // border: "1px solid #cc0000",
                borderRadius: 20,
                height: 30,
                width: 30,
                display: "flex",
                cursor: "pointer"
            }}
                onClick={() => props.removeLineItem(props.index)} >
                <div className='w-100 d-flex justify-content-center align-items-center'>
                    <i className='fa fa-close' style={{ color: colors.red }} />
                </div>
            </div>}
        </Container>
    )
}


export default AnnotationPhone